// extracted by mini-css-extract-plugin
module.exports = {"root":"_3sNPy","avatar":"_1d-Rb"};